// Типы действий среза devTools (отладочные флаги).
export const SET_IS_DEBUG = 'devTools/SET_IS_DEBUG';
